// src/components/FloatingAssistant.js
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PapChatLoader from './PapChatLoader';
import { useAiContext } from '../hooks/useAiContext';
import { useDoorloopjes } from '../context/DoorloopjesContext';
import { usePapConversation } from '../hooks/usePapConversation';

const FloatingAssistant = () => {
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  
  const { currentUser } = useDoorloopjes();
  const getContext = useAiContext();

  // Koppeling tussen de chatwidget en het account (actief gesprek, gesprekkenlijst)
  const { getConversationId, onConversationIdUpdate, onConversationReset } = usePapConversation();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const checkMobile = () => setIsMobile(window.matchMedia('(max-width: 768px)').matches);
    checkMobile(); 
    setIsMounted(true); 
    
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const isDashboard = location.pathname === '/dashboard';

  const isPublicPage = 
    location.pathname === '/' || 
    location.pathname.startsWith('/info/') || 
    location.pathname.startsWith('/voorbeeld/') ||
    location.pathname.startsWith('/nieuws/') || 
    location.pathname === '/reset-password' || 
    location.pathname === '/verify-email';

  if (!isMounted) return null;

  // --- WIJZIGING START: Alleen tonen als gebruiker is ingelogd ---
  if (!currentUser) {
    return null;
  }
  // --- WIJZIGING EIND ---

  if (isDashboard && !isMobile) {
    return null;
  }

  const hasBottomMenu = isMobile && !isPublicPage;
  const startState = hasBottomMenu ? 'hidden' : 'minimized';
  const minimizeAction = hasBottomMenu ? 'hide' : 'minimize';

  // Omdat we hierboven al returnen als !currentUser, is isUserLoggedIn hier altijd true.
  // We laten de variabele staan voor consistentie met de prop naamgeving.
  const isUserLoggedIn = true; 
  const storageMode = 'integrated';

  return (
    <PapChatLoader 
      mode="floating" 
      assistantId="doorloopjes"
      initialState={startState}
      minimizeAction={minimizeAction}
      context={getContext}
      storageMode={storageMode}
      // Gebruik de stabiele callbacks als de gebruiker is ingelogd
      getConversationId={getConversationId}
      onConversationIdUpdate={onConversationIdUpdate}
      onConversationReset={onConversationReset}
    />
  );
};

export default FloatingAssistant;